
import { Button, Drawer } from 'element-ui';
import Teleport from 'vue2-teleport';
import { OrderHelper } from '~/helpers/OrderHelper';
import { ExternalLinkIcon } from 'vue-feather-icons';

export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      tracking: null,
      orderHelper: new OrderHelper(this.$http,
        this.$store,
        this.$i18n.locale),
    };
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return date.toLocaleString(this.$i18n.locale, {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    async fetchTracking() {

      try {
        const response = await this.orderHelper.getOrderTracking({
          idOrder: this.order.IdOrder,
          languageIsoCode: this.$i18n.locale,
        });


        if (response) {
          this.tracking = response?.data;
        }
      } catch (e) {
        console.error(e);
      }

    },
  },
  components: {
    Button,
    Drawer,
    ExternalLinkIcon
  },
};
